import React, { useEffect, useState } from "react";
import clsx from "clsx";
import styles from "./RecycledProductList.module.scss";
import recycledProductApi from "../../../apis/recycledProductApi";
import { useSnackbar } from "notistack";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import ModalRecycledProduct from "../Modal/Modal";

const RecycledProductList = () => {
  const [products, setProducts] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [itemEdit, setItemEdit] = useState<any>(null);
  const [reload, setReload] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  
  const [nextPage, setNextPage] = useState({
    offset: 0,
    limit: 20,
  });

  const getList = async () => {
    setLoading(true);
    try {
      const res = await recycledProductApi.getList({
        filter: {},
        paging: {
          limit: nextPage.limit,
          offset: nextPage.offset,
        },
      });
      if (res?.data?.code === 0) {
        setProducts(res.data.data.products || []);
      } else {
        enqueueSnackbar(res?.data?.message || "Lỗi", { variant: "error" });
      }
    } catch (err) {
      console.log(err);
    }
    setLoading(false);
  };

  useEffect(() => {
    getList();
  }, [reload, nextPage.offset]);

  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [idToDelete, setIdToDelete] = useState<string | null>(null);

  const handleOpenDeleteConfirm = (id: string) => {
    setIdToDelete(id);
    setOpenDeleteConfirm(true);
  };

  const handleCloseDeleteConfirm = () => {
    setOpenDeleteConfirm(false);
    setIdToDelete(null);
  };

  const handleDelete = async () => {
    if (!idToDelete) return;
    try {
      const res = await recycledProductApi.delete({ id: idToDelete });
      if (res.data.code === 0) {
        enqueueSnackbar("Xóa thành công", { variant: "success" });
        setReload(!reload);
      } else {
        enqueueSnackbar(res.data.message, { variant: "error" });
      }
      handleCloseDeleteConfirm();
    } catch (err) {
      console.log(err);
      handleCloseDeleteConfirm();
    }
  };

  const handleOpenAdd = () => {
    setItemEdit(null);
    setOpenModal(true);
  };

  const handleOpenEdit = (item: any) => {
    setItemEdit(item);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSuccess = () => {
    setReload(!reload);
    setOpenModal(false);
  };

  return (
    <div className={styles.root}>
      <div className={styles.addBtn}>
        <Button variant="contained" onClick={handleOpenAdd}>
          Thêm sản phẩm mới
        </Button>
      </div>

      <div className={styles.tableWrap}>
        <table>
          <thead>
            <tr>
              <th>STT</th>
              <th>Hình ảnh</th>
              <th>Tên sản phẩm</th>
              <th>Giá tiền (VNĐ)</th>
              <th>Trạng thái</th>
              <th>Thao tác</th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>Đang tải...</td>
              </tr>
            ) : products.length === 0 ? (
              <tr>
                <td colSpan={6} style={{ textAlign: "center" }}>Chưa có dữ liệu</td>
              </tr>
            ) : (
              products.map((item, index) => (
                <tr key={item.id}>
                  <td>{nextPage.offset + index + 1}</td>
                  <td>
                    {item.image && (
                      <img src={item.image} alt={item.name} className={styles.imgPreview} />
                    )}
                  </td>
                  <td>{item.name}</td>
                  <td>{item.price?.toLocaleString()}</td>
                  <td>{item.isActive ? "Đang bật" : "Đã tắt"}</td>
                  <td>
                    <span className={styles.actionBtn} onClick={() => handleOpenEdit(item)}>
                      Sửa
                    </span>
                    <span
                      className={clsx(styles.actionBtn, styles.deleteBtn)}
                      onClick={() => handleOpenDeleteConfirm(item.id)}
                    >
                      Xóa
                    </span>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      <div className={styles.pagination}>
        <button
          disabled={nextPage.offset === 0}
          onClick={() => setNextPage({ ...nextPage, offset: nextPage.offset - nextPage.limit })}
        >
          &laquo; Prev
        </button>
        <button
          disabled={products.length < nextPage.limit}
          onClick={() => setNextPage({ ...nextPage, offset: nextPage.offset + nextPage.limit })}
        >
          Next &raquo;
        </button>
      </div>

      {openModal && (
        <ModalRecycledProduct
          open={openModal}
          handleClose={handleCloseModal}
          itemEdit={itemEdit}
          onSuccess={handleSuccess}
        />
      )}

      <Dialog
        open={openDeleteConfirm}
        onClose={handleCloseDeleteConfirm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {"Xác nhận xóa"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Bạn có chắc chắn muốn xóa sản phẩm này không? Hành động này không thể hoàn tác.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteConfirm}>Hủy</Button>
          <Button onClick={handleDelete} autoFocus color="error">
            Xóa
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default RecycledProductList;
